import React from 'react'
import { TransactionList } from './list/page'

export const TransactionPage = (): JSX.Element => {
  return <TransactionList />
}
